<app-basic-select [options]="countries" [(ngModel)]="localValue" [iconClass]="'globe-europe-africa fw-semibold'" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
